import {
	ConferencePlatformErrorsType,
	ConferencePlatformType,
	InterviewDetailsErrorsType,
	InterviewDetailsType,
} from "./types";

export function getDefaultInterviewDetails(): InterviewDetailsType {
	const startTime = new Date();
	startTime.setMinutes(0, 0, 0);
	startTime.setHours(startTime.getHours() + 1);

	const endTime = new Date(startTime.getTime() + 1 * 60 * 60 * 1000);

	return {
		title: "",
		candidateName: "",
		candidateEmail: "",
		positionName: "",
		interviewerUuids: [],
		startTime,
		endTime,
	};
}

export const defaultInterviewDetailsErrors: InterviewDetailsErrorsType = {
	title: "",
	candidateName: "",
	candidateEmail: "",
	positionName: "",
	interviewerUuids: "",
	startTime: "",
	endTime: "",
};

export const defaultConferencePlatform: ConferencePlatformType = {
	videoPlatform: null,
	meetingLink: "",
	notes: "",
};

export const defaultConferencePlatformErrors: ConferencePlatformErrorsType = {
	videoPlatform: "",
	meetingLink: "",
	notes: "",
};
